import { SchoolPluginEntryUrls } from './school-plugin-entry-urls'
import { SchoolPluginScope } from './school-plugin-scope'
import { PluginStatusEnum } from './plugin-status-enum'
import { Term } from './term'
import { Plugin } from './plugin'
import { SchoolPluginConfig } from './school-plugin-config'

export interface SchoolPluginInterface {
  pluginId?: number
  /**
   * 应用名称(页面显示用)
   */
  label?: string
  /**
   * 应用图标
   */
  icon?: string | null
  /**
   * 应用描述
   */
  description?: string
  /**
   * 应用分类ID
   */
  tagId?: number
  /**
   * 网址设置 {"web": "a.com", "mobile":"b.com"}
   */
  entryUrls?: SchoolPluginEntryUrls
  /**
   * 用户范围 {"ids":[1],"student_ids":[1],"teacher_ids":[2]}
   */
  scopes?: SchoolPluginScope
  status?: PluginStatusEnum
  /**
   * 全部内排序值
   */
  weight?: number
  /**
   * 分组内排序值
   */
  groupWeight?: number
  tag?: Term | null
  /**
   * 关联的应用商店应用
   */
  plugin?: Plugin | null
  /**
   * 学校应用 oauth 配置
   */
  config?: SchoolPluginConfig | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class SchoolPlugin implements SchoolPluginInterface {
  pluginId?: number
  /**
   * 应用名称(页面显示用)
   */
  label?: string
  /**
   * 应用图标
   */
  icon?: string | null
  /**
   * 应用描述
   */
  description?: string
  /**
   * 应用分类ID
   */
  tagId?: number
  /**
   * 网址设置 {"web": "a.com", "mobile":"b.com"}
   */
  entryUrls?: SchoolPluginEntryUrls
  /**
   * 用户范围 {"ids":[1],"student_ids":[1],"teacher_ids":[2]}
   */
  scopes?: SchoolPluginScope
  status?: PluginStatusEnum
  /**
   * 全部内排序值
   */
  weight?: number
  /**
   * 分组内排序值
   */
  groupWeight?: number
  tag?: Term | null
  /**
   * 关联的应用商店应用
   */
  plugin?: Plugin | null
  /**
   * 学校应用 oauth 配置
   */
  config?: SchoolPluginConfig | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: SchoolPluginInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      pluginId: _pluginId,
      label: _label,
      icon: _icon,
      description: _description,
      tagId: _tagId,
      entryUrls: _entryUrls,
      scopes: _scopes,
      status: _status,
      weight: _weight,
      groupWeight: _groupWeight,
      tag: _tag,
      plugin: _plugin,
      config: _config,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.pluginId = _pluginId
    this.label = _label
    this.icon = _icon
    this.description = _description
    this.tagId = _tagId
    this.entryUrls = _entryUrls
      ? new SchoolPluginEntryUrls(_entryUrls)
      : _entryUrls
    this.scopes = _scopes ? new SchoolPluginScope(_scopes) : _scopes
    this.status = _status
    this.weight = _weight
    this.groupWeight = _groupWeight
    this.tag = _tag ? new Term(_tag) : _tag
    this.plugin = _plugin ? new Plugin(_plugin) : _plugin
    this.config = _config ? new SchoolPluginConfig(_config) : _config
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
